// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Albania from '../_raw/flag/icon_flag_albania.png';

export default () => <img src={Albania} alt="Albania" />;
